import { atom } from "jotai";

export const showReportAtom = atom(false)